"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Back_1 = __importDefault(require("@kawaui/icons/build/icons/navigation/Back"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const link_1 = __importDefault(require("../../link"));
const Styled = __importStar(require("./styles"));
const SubMenu = ({ isOpen, items, handleClose, title: subMenuTitle }) => {
    const [isSubPageOpen, setIsSubPageOpen] = (0, react_1.useState)(false);
    const [subPageTitle, setSubPageTitle] = (0, react_1.useState)('');
    const [subPageContent, setSubPageContent] = (0, react_1.useState)('');
    const handleClick = (title, content) => {
        if (!content)
            return;
        setIsSubPageOpen(true);
        setSubPageTitle(title || '');
        setSubPageContent(content);
    };
    const renderSubPage = () => {
        if (!isSubPageOpen)
            return null;
        const handleSubPageClose = () => setIsSubPageOpen(false);
        return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isSubPageOpen, timeout: 200, mountOnEnter: true, unmountOnExit: true, classNames: "header--menu", "data-facil-iti": "header-menu-button", children: (0, jsx_runtime_1.jsxs)(Styled.Content, { children: [renderTitle(subPageTitle, handleSubPageClose), (0, jsx_runtime_1.jsx)(Styled.SubPageContent, { dangerouslySetInnerHTML: { __html: subPageContent } })] }) }));
    };
    const renderTitle = (title, handleClick) => ((0, jsx_runtime_1.jsxs)(Styled.Header, { children: [(0, jsx_runtime_1.jsx)(Styled.BackButton, { onClick: handleClick, children: (0, jsx_runtime_1.jsx)(Back_1.default, {}) }), (0, jsx_runtime_1.jsx)(Styled.Title, { children: title })] }));
    if (!items || items.length < 1)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 200, mountOnEnter: true, unmountOnExit: true, classNames: "header--menu", "data-facil-iti": "header-submenu-button", children: (0, jsx_runtime_1.jsxs)(Styled.Content, { children: [renderTitle(subMenuTitle, handleClose), (0, jsx_runtime_1.jsx)(Styled.List, { children: items.map((item) => ((0, jsx_runtime_1.jsx)(Styled.ListItem, { children: (0, jsx_runtime_1.jsx)(link_1.default, { href: item.defaultUrl, variant: "tertiary", forcedExternal: true, onClick: () => handleClick(item.text, item.content), children: item.text }) }, item.text))) })] }) }), renderSubPage()] }));
};
exports.default = SubMenu;
